import lang from '@/lang'
import React from 'react'
import { Route } from 'react-router'
const BookingList = React.lazy(() => import('@/modules/booking/components/list/booking-list'))

const bookingRoutes = (
  <>
    <Route path='bookings' Component={BookingList} handle={{ title: lang.bookings.title, options: { noBackgroundColor: true } }} />
  </>
)

export default bookingRoutes
